import type {
  RewardTierConfiguration,
  SnappyIntegrationConfig
} from 'settings/Settings.types';
import { isNumber } from 'common/utils/numbers';

export const areThresholdsValid = (
  rewards: RewardTierConfiguration[],
  thresholdsEnabled: boolean
) => {
  if (!thresholdsEnabled) return true;
  const thresholdsPresent = rewards.every(
    reward => isNumber(reward.threshold) && reward.threshold > 0
  );

  return thresholdsPresent || 'All thresholds must have a value greater than 0';
};

export const areThresholdsActive = (
  thresholdsEnabled: boolean,
  snappyIntegration: SnappyIntegrationConfig
) => {
  if (!snappyIntegration.active) return true;

  return (
    thresholdsEnabled ||
    "In order to automate fulfillment with Snappy, you'll need to add Rewards Thresholds before continuing."
  );
};
